import { render } from "./BenevolePage.vue?vue&type=template&id=8b939bb0"
import script from "./BenevolePage.vue?vue&type=script&lang=js"
export * from "./BenevolePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__